import { render, staticRenderFns } from "./Myrobot.vue?vue&type=template&id=2b052caa&"
import script from "./Myrobot.vue?vue&type=script&lang=js&"
export * from "./Myrobot.vue?vue&type=script&lang=js&"
import style0 from "./Myrobot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports